import React, { useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import './NotFound.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FaHome, FaExclamationTriangle } from 'react-icons/fa';

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 10000); // Redirect after 10 seconds

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | RAD EnviroNex</title>
        <meta name="description" content="The page you are looking for does not exist. Return to the RAD EnviroNex home page for solar and environmental solutions in Madurai." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://radenvironex.com/NotFound" />
      </Helmet>
      <Navbar />

      <div className="notfound-container">
        <div className="notfound-content" data-aos="zoom-in">
          <div className="notfound-icon">
            <FaExclamationTriangle />
          </div>
          <h1 className="notfound-title">404</h1>
          <h2 className="notfound-subtitle">Page Not Found</h2>
          <p className="notfound-text">
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>
          <p className="notfound-timer">Redirecting to Homepage in 10 seconds...</p>
          <button className="notfound-btn" onClick={() => navigate('/')}>
            <FaHome /> Back to Home
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
